import { dataGirlSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconGirlSolid = /*#__PURE__*/createIcon(dataGirlSolid)
export default IconGirlSolid
